export default "/images/check.svg?5fabb75d79d3214034bb738f4a21f138";